import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function FinancialInfoCard({ data }) {
  // Debug: afficher les données reçues
  console.log('📊 FinancialInfoCard - Données reçues:', data);
  console.log('💰 FormuleTI:', data?.FormuleTI);
  console.log('💰 GesteC:', data?.GesteC);
  console.log('💰 caution:', data?.caution);
  console.log('💰 STATUT:', data?.STATUT);
  console.log('💰 Contrav:', data?.Contrav);
  console.log('💰 solldeinterieur:', data?.solldeinterieur);
  console.log('💰 AvanceCarburant:', data?.AvanceCarburant);

  if (!data) {
    return (
      <Card>
        <MDBox p={2}>
          <MDTypography variant="h6" fontWeight="medium">
            Informations Financières
          </MDTypography>
          <MDBox mt={2}>
            <MDTypography variant="button" color="text">
              Aucune information disponible
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    );
  }

  // Fonction helper pour formater les montants
  const formatAmount = (value) => {
    if (value === null || value === undefined) return "0,00 €";
    if (value === 0) return "0,00 €";
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "0,00 €";
    return num.toFixed(2).replace(".", ",") + " €";
  };

  // Déterminer la couleur du solde intérieur
  const getSoldeColor = (solde) => {
    if (solde === null || solde === undefined) return "text";
    if (solde < 0) return "error";
    if (solde > 0) return "success";
    return "text";
  };

  const soldeInterieur = data.solldeinterieur || data.soldeinterieur || 0;

  return (
    <Card>
      <MDBox p={2}>
        <MDBox mb={2}>
          <MDTypography variant="h6" fontWeight="medium">
            Informations Financières
          </MDTypography>
          <MDTypography variant="button" color="text" fontWeight="regular">
            {data.nom}
          </MDTypography>
        </MDBox>

        <Divider />

        {/* Formule Tout Inclus */}
        <MDBox mt={2}>
          <MDBox display="flex" justifyContent="space-between" mb={1}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Formule Tout Inclus:
            </MDTypography>
            <MDTypography variant="button" fontWeight="bold" color="info">
              {formatAmount(data.FormuleTI)}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Divider />

        {/* Geste Commercial */}
        <MDBox mt={2}>
          <MDBox display="flex" justifyContent="space-between" mb={1}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Geste Commercial:
            </MDTypography>
            <MDTypography
              variant="button"
              fontWeight="bold"
              color={data.GesteC && data.GesteC !== 0 ? "warning" : "text"}
            >
              {formatAmount(data.GesteC)}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Divider />

        {/* Caution */}
        <MDBox mt={2}>
          <MDBox display="flex" justifyContent="space-between" mb={1}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Caution:
            </MDTypography>
            <MDTypography variant="button" fontWeight="bold">
              {formatAmount(data.caution)}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Divider />

        {/* Statut */}
        <MDBox mt={2}>
          <MDBox display="flex" justifyContent="space-between" mb={1}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Statut:
            </MDTypography>
            <MDTypography variant="button" fontWeight="bold">
              {data.STATUT || data.statut || "Non défini"}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Divider />

        {/* Contraventions */}
        <MDBox mt={2}>
          <MDBox display="flex" justifyContent="space-between" mb={1}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Contraventions:
            </MDTypography>
            <MDTypography
              variant="button"
              fontWeight="bold"
              color={data.Contrav && data.Contrav !== 0 ? "error" : "text"}
            >
              {formatAmount(data.Contrav)}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Divider />

        {/* Avance Carburant */}
        <MDBox mt={2}>
          <MDBox display="flex" justifyContent="space-between" mb={1}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Avance Carburant:
            </MDTypography>
            <MDTypography variant="button" fontWeight="bold">
              {formatAmount(data.AvanceCarburant)}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Divider />

        {/* Solde Intérieur - Mise en évidence */}
        <MDBox
          mt={2}
          p={2}
          sx={{
            backgroundColor: soldeInterieur < 0
              ? "#ffebee"
              : soldeInterieur > 0
              ? "#e8f5e9"
              : "#f5f5f5",
            borderRadius: "8px",
          }}
        >
          <MDBox textAlign="center">
            <MDTypography variant="caption" color="text" fontWeight="regular">
              Solde Intérieur
            </MDTypography>
            <MDTypography
              variant="h3"
              fontWeight="bold"
              color={getSoldeColor(soldeInterieur)}
            >
              {formatAmount(soldeInterieur)}
            </MDTypography>
            <MDTypography variant="button" color="text">
              {soldeInterieur < 0 ? "À régler" : soldeInterieur > 0 ? "Crédit" : "Neutre"}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

FinancialInfoCard.propTypes = {
  data: PropTypes.shape({
    nom: PropTypes.string,
    FormuleTI: PropTypes.number,
    GesteC: PropTypes.number,
    caution: PropTypes.number,
    statut: PropTypes.string,
    STATUT: PropTypes.string,
    Contrav: PropTypes.number,
    solldeinterieur: PropTypes.number,
    soldeinterieur: PropTypes.number,
    AvanceCarburant: PropTypes.number,
  }),
};

FinancialInfoCard.defaultProps = {
  data: null,
};

export default FinancialInfoCard;
